// extracted by mini-css-extract-plugin
export default {"regulatoryComplianceToggles":"lCL9VDoBcqX563dqVy9q","label":"wvHze8X45UHtTzIyAuiD","toggle":"W2TVZvj4de9ql2PzTIEq","description":"K6OOegFSduBYTXNuaAf0"};